import { DemonstrativoReceitaEDespesaItem } from "features/relatorios/typings";
import { formatMoney } from "infra/helpers/number";
import { useMemo } from "react";
import { PDFTableColumn } from "components/PDF/Table";
import { View, Text } from "@react-pdf/renderer";
import colors from "core/resources/theme/colors";

function useRelatorioDemonstrativoReceitaDespesaPdfColumns({
  title,
  noPercentage,
  somarSubcategorias,
}: {
  title?: string;
  noPercentage?: boolean;
  somarSubcategorias?: boolean;
}): PDFTableColumn<DemonstrativoReceitaEDespesaItem>[] {
  return useMemo(() => {
    const columns: PDFTableColumn<DemonstrativoReceitaEDespesaItem>[] = [];

    const commonStyles = (hasChildren = false) =>
      ({
        color: colors.black,
        fontSize: 7,
        fontWeight: hasChildren ? "medium" : undefined,
      } as Record<string, string | number>);

    columns.push({
      title: title || "",
      flexGrow: 4,
      render: (original) => {
        const breadcrumbLevel = original.breadcrumb?.match(/\./g)?.length || 0;
        return (
          <View>
            <Text
              style={{
                paddingLeft: breadcrumbLevel * 10,
                ...commonStyles(!!original.items.length),
              }}
            >
              {original.breadcrumb} {original.nome}
            </Text>
          </View>
        );
      },
    });

    if (!noPercentage) {
      columns.push({
        title: "Porcentagem (%)",
        width: "5cm",
        render: (original) => (
          <View>
            <Text style={{ ...commonStyles(!!original.items.length) }}>
              {original.items.length && !original.valor
                ? ""
                : original.porcentagem + "%"}
            </Text>
          </View>
        ),
      });
    }

    columns.push({
      title: "Valor",
      width: "4cm",
      textAlign: "right",
      render: (original) => (
        <View>
          <Text style={{ ...commonStyles(!!original.items.length) }}>
            {somarSubcategorias && original.items.length
              ? formatMoney((original.valor ?? 0) + original.valorItems)
              : original.valor
              ? formatMoney(original.valor)
              : null}
          </Text>
        </View>
      ),
    });

    return columns;
  }, [title, noPercentage, somarSubcategorias]);
}

export default useRelatorioDemonstrativoReceitaDespesaPdfColumns;
